<template>
  <ListInline size="small">
    <li v-if="emergencyEnabled">
      <CallButton
        :id="localUsername"
        type="emergency"
        variant="outline"
        @call-started="$emit('call-started')"
      />
    </li>
    <li>
      <CallButton :id="localUsername" @call-started="$emit('call-started')" />
    </li>
    <slot name="post-actions" />
  </ListInline>
</template>

<script>
import CallButton from '@/components/voip/CallButton';

export default {
  components: {
    CallButton,
  },

  props: {
    user: {
      type: Object,
      default: null,
    },
    users: {
      type: Array,
      default: null,
    },
    username: {
      type: String,
      default: null,
    },
    enableEmergencyCall: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    localUser() {
      return (
        this.user ||
        this.users ||
        this.$store.getters['users/getUserByUsername'](this.username) ||
        {}
      );
    },

    localUsername() {
      return (
        this.username ||
        this.localUser.username ||
        this.localUser.map(user => user?.username).join(',')
      );
    },

    emergencyEnabled() {
      return this.enableEmergencyCall && this.localUser.type === 'bus';
    },
  },
};
</script>
